import React from 'react';
import { useI18n } from '../context/I18nContext';
import { useCurrency, appendCurrency } from '../context/CurrencyContext';
import { ZHELTA_SHOP_URL } from '../mock';

export default function ShopSection() {
  const { t } = useI18n();
  const { currency } = useCurrency();
  const shopUrl = appendCurrency(ZHELTA_SHOP_URL, currency);

  return (
    <section className="py-12 sm:py-14 md:py-20 bg-white">
      <div className="zh-container">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center">
          {/* Left image card — aspect-ratio gives proportional scaling at
              every breakpoint without the old fixed-height awkwardness. */}
          <div className="rounded-2xl overflow-hidden shadow-md bg-gray-100 aspect-[4/3] sm:aspect-[16/10] md:aspect-[4/3]">
            <img
              src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1200&q=80"
              srcSet="
                https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=480&q=75 480w,
                https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=800&q=78 800w,
                https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1200&q=80 1200w,
                https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&w=1800&q=82 1800w
              "
              sizes="(max-width: 767px) 100vw, 50vw"
              alt="Shop ZHELTA Services"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right stacked card */}
          <div className="relative">
            {/* Gray offset card behind (inset slightly more on mobile so the
                shadow plate never overflows past the viewport). */}
            <div
              className="absolute -top-3 sm:-top-4 left-3 sm:left-4 right-3 sm:right-4 h-full rounded-2xl bg-gray-300/70"
              aria-hidden="true"
            />
            <div className="relative bg-white rounded-2xl p-6 sm:p-7 md:p-10 shadow-sm">
              <h2 className="text-xl sm:text-2xl md:text-[30px] font-bold text-gray-900 text-center leading-tight mb-4 sm:mb-5">
                {t.shop.title_a} <br />
                {t.shop.title_b}
              </h2>
              <p className="text-gray-500 text-center text-[14px] sm:text-[15px] leading-relaxed mb-6 sm:mb-8">
                {t.shop.body}
              </p>
              <div className="flex justify-center">
                <a
                  href={shopUrl}
                  className="w-full max-w-md py-3 sm:py-3.5 rounded-full text-white font-semibold tracking-wide text-[14px] sm:text-[15px] hover:brightness-105 transition-all text-center block"
                  style={{
                    background: 'linear-gradient(90deg, #ffb347 0%, #f5a623 50%, #ff8c1a 100%)',
                    boxShadow: '0 15px 30px -10px rgba(245, 140, 25, 0.5)',
                  }}
                >
                  {t.shop.cta}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
